import { ICustomerProfile, ICustomerProfileValidation } from '../types';
import { defaultValidation } from 'src/constants/main';

export const defaultCustomerProfile: ICustomerProfile = {
  id: 0,
  name: '',
  gender: null,
  birth_day: null,
  mobile: '',
  email: null,
  created_at: null,
  first_order: null,
  last_order: null,
  order_total_sum: 0,
  order_total_count: 0,
  order_total_avg: 0,
  wallet: 0,
  status: 1,
  //
  is_draft: true,
};

export const defaultCustomerProfileValidation: ICustomerProfileValidation = {
  isValid: true,
  email: defaultValidation,
};
